<template>
    <div class="input_container">
        <van-field v-model="localValue" clearable :placeholder="labelText" :readonly="true">
            <template #button>
                <button class="copy-btn" @click="handleCopyValue">
                    {{ $t('common.copy') }}
                </button>
            </template>
        </van-field>

        <StatusPopup ref="statusRef" :content="$t('common.copied')" :isShowSuccess="true" />
    </div>
</template>


<script setup lang="ts">
import StatusPopup from '@/components/common/statusPopup.vue'
import { copyValue } from '@/view/bauDoTesouro/supportScript'
import { ref, watch, defineProps, defineEmits } from 'vue'

const props = defineProps({
    modelValue: {
        type: String,
        default: ''
    },
    labelText: {
        type: String,
        default: ''
    },
    isTopupVisible: {
        type: Boolean,
        default: false
    },
    giftAmount: {
        type: Number,
        default: 0
    }
})
const statusRef = ref()
const emit = defineEmits(['update:modelValue', 'valueChanged'])

const localValue = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
    localValue.value = newVal
})

watch(localValue, (val) => {
    emit('update:modelValue', val)
    emit('valueChanged', val)
})

const handleCopyValue = () => {
  copyValue(localValue.value, () => {
    statusRef.value?.open()
  })
}
</script>
<style scoped>
.input_container>>>.van-field {
    border-radius: 10px;
    background: #00000040 !important;
    color: #ffffffa6;
    padding: 6px 5px 5px !important;
    margin-top: 10px;
}

.left_icon {
    color: #f9c486;
    font-weight: bold;
    padding-right: 3px;
}

.input_container>>>.van-field__control {
    color: #86718c !important;
    font-size: 12px;

}

.input_container>>>.van-field__control::placeholder {
    color: #86718c !important;
}

.input_container>>>.van-field__clear {
    opacity: 0.5 !important;
}
.input_container>>>.van-cell:after {
    border: none
}
.input_container img {
    width: 80%;
}

.right_text {
    color: #ffffff73;
}

.extra_amount {
    color: #fff;
    padding: 0 5px;
}
.input_container>>>.van-field__button{
    width: 20%;
    display: flex;
    justify-content: center;
}

/* ✅ New button styling */
.copy-btn {
  background-color: #ff3d9e;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.copy-btn:hover {
  background-color: #e7338b;
}

.copy-btn:active {
  background-color: #cc2a7a;
}
</style>